module.exports = __webpack_public_path__ + "img/problems-3.a178aabd.png";